export default "__VITE_ASSET__BxsQj8jl__"